<template>
  <div class="col-md-3 col-sm-12 col-xs-12">
    <q-select
      dense
      outlined
      v-model="funcionario"
      use-input
      hide-selected
      fill-input
      input-debounce="0"
      hint="Digite 3 caracteres para filtrar"
      :options="listaFuncionarios"
      @filter="filterFn"
      :option-label="
        (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
      "
      :rules="[(val) => val || 'Campo Obrigatório']"
    >
    </q-select>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  name: "SelectFuncioario",
  emits: ["emitirFuncionario"],
  setup(props, { emit }) {
    const store = useStore();
    const time = ref();
    const funcionario = ref({
      id: "",
      nome: "",
    });

    const listaFuncionarios = ref([]);

    let listarFuncionarios = async (search) => {
      try {
        let resposta = await store.dispatch("fer/listarUsuarios", {
          search,
        });

        listaFuncionarios.value = resposta.listaFuncionarios;
      } catch (error) {
        console.error(error);
      }
    };

    watch(funcionario, () => {
      emitirFuncionario(funcionario);
    });

    let emitirFuncionario = async (funcionario) => {
      emit("emitirFuncionario", funcionario);
    };

    return {
      funcionario,
      emitirFuncionario,
      listaFuncionarios,
      listarFuncionarios,

      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarFuncionarios(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}
</style>
